/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { confirmAccount } from '../core/_requests'
import { showAlert, showAlertLoading, showError } from '../../../../_metronic/helpers'
import { TokenDtoValidate } from '../core/_models'
import { LoadingIndicator } from '../../../components/Loading/LoadingIndicator'

type ConfirmAccountStatus = 'loading' | 'success' | 'error'

export const ConfirmAccount = () => {
  const [searchParams] = useSearchParams()

  const token = searchParams.get('token')
  const navigate = useNavigate()

  const [status, setStatus] = useState<ConfirmAccountStatus>(token ? 'loading' : 'error')

  const ativaConta = useCallback(async () => {
    try {
      if (token) {
        showAlertLoading()
        const data: TokenDtoValidate = {
          token,
        }
        await confirmAccount(data)
        await showAlert({
          title: 'Sucesso!',
          text: 'Conta confirmada com sucesso.',
          icon: 'success',
        })
        setStatus('success')
        navigate(`/reset-password?token=${token}`)
      }
    } catch (error) {
      setStatus('error')
      await showError(error)
      navigate('/auth')
    }
  }, [navigate, token])

  useEffect(() => {
    ativaConta()
  }, [ativaConta])

  return (
    <div className='text-center'>
      <h1 className='fs-2x mb-5'>Bem-vindo à Lauduz</h1>

      {status === 'loading' && <LoadingIndicator message='Confirmando sua conta...' />}

      {status === 'success' && (
        <div className='text-primary fs-5'>Conta confirmada! Redirecionando...</div>
      )}

      {status === 'error' && (
        <div className='text-muted fs-5'>
          {token
            ? 'Não foi possível confirmar sua conta. Redirecionando...'
            : 'Link inválido ou expirado.'}
        </div>
      )}
    </div>
  )
}
